import React from 'react'
import styled, { keyframes } from 'styled-components'
import { LoaderCircle } from '@styled-icons/boxicons-regular'
import { NavLink } from 'react-router-dom'

const ContainerButton = styled.div<{ buttonStyle: 'primary' | 'secondary', outline: boolean, className: string }>`
  width: fit-content;
  border-radius: 8px;
  padding: 5px 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 30px;
  min-width: 100px;
  cursor: pointer;
  margin: auto;
  padding: 6px 20px;
  color: white;
  text-decoration: none;
  transition: .2s;
  height: 42px;
  background: ${p => p.buttonStyle === 'primary' ? p.theme.palette.primary.main : p.theme.palette.secondary.main};
  border: 1px solid ${p => p.buttonStyle === 'primary' ? p.theme.palette.primary.main : p.theme.palette.secondary.main};

  :hover{
    background: ${p => p.buttonStyle === 'primary' ? p.theme.palette.secondary.main : p.theme.palette.primary.main};
    border: 1px solid ${p => p.buttonStyle === 'primary' ? p.theme.palette.secondary.main : p.theme.palette.primary.main};
  }
  
  ${p => p.className}
`

const ContainerButtonLink = styled(NavLink)<{ buttonStyle: 'primary' | 'secondary', outline: boolean, className: string }>`
  width: fit-content;
  height: 42px;
  border-radius: 8px;
  padding: 5px 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 30px;
  min-width: 100px;
  cursor: pointer;
  margin: auto;
  padding: 6px 20px;
  color: white;
  text-decoration: none;
  transition: .2s;
  background: ${p => p.buttonStyle === 'primary' ? p.theme.palette.primary.main : p.theme.palette.secondary.main};
  border: 1px solid ${p => p.buttonStyle === 'primary' ? p.theme.palette.primary.main : p.theme.palette.secondary.main};

  :hover{
    background: ${p => p.buttonStyle === 'primary' ? p.theme.palette.secondary.main : p.theme.palette.primary.main};
    border: 1px solid ${p => p.buttonStyle === 'primary' ? p.theme.palette.secondary.main : p.theme.palette.primary.main};
  }
  
  ${p => p.className}
`
const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`
const ContainerLoader = styled.div`
  width: 50%;
  height: 100%;
  color: white;
  animation: ${rotate} 1.5s linear infinite;
`
const ContainerIcon = styled.div`
  width: 15px;
  color: white;
  margin-left: 10px
`

const ContainerBody = styled.div`
  width: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-content: center;
  
  > p{
    font-weight: bold !important;
    text-decoration: none;
    color: white;
  }
`

interface IOwnProps{
  text: string;
  icon?: React.ReactElement;
  outline?: boolean;
  isLoading?: boolean;
  buttonStyle?: 'primary' | 'secondary';
  className?: string;
  to?: string;
  onClick?: () => void
}

const ButtonTC: React.FunctionComponent<IOwnProps> = ({
  to,
  icon,
  text,
  isLoading,
  outline = false,
  buttonStyle = 'primary',
  className = '',
  onClick = () => console.log
}) => {
  return (
    <>
    {!!to ? (
      <ContainerButtonLink
        buttonStyle={buttonStyle}
        outline={outline}
        className={className}
        onClick={onClick}
        to={to}
      >
        {isLoading ? (
          <ContainerLoader>
            <LoaderCircle />
          </ContainerLoader>
        ): (
          <ContainerBody>
            <p>{text}</p>
            {icon && <ContainerIcon>{icon}</ContainerIcon> }
          </ContainerBody>
        )}
          
      </ContainerButtonLink>
    ) : (
      <ContainerButton
        buttonStyle={buttonStyle}
        outline={outline}
        className={className}
        onClick={onClick}
      >
        {isLoading ? (
          <ContainerLoader>
            <LoaderCircle />
          </ContainerLoader>
        ): (
          <ContainerBody>
            <p>{text}</p>
            {icon && <ContainerIcon>{icon}</ContainerIcon> }
          </ContainerBody>
        )}
          
      </ContainerButton>
    )}
    </>
  )
}

export default ButtonTC